import React from "react";


import Footer from "../../components/common/Footer";

import "../../assets/css/about.css";

import Banner from "../../assets/images/about/banner.jpg";
import Studio from "../../assets/images/about/studio.jpg";
import AdminNavbar from "../AdminNavbar";

function AdminAbout() {

    return (

        <>

            <AdminNavbar />

            {/*=========================================================
                            LUXURY HERO BANNER
            =========================================================*/}

            <section
                className="about-banner"
                style={{
                    backgroundImage:
                        `linear-gradient(rgba(0,0,0,.72),rgba(0,0,0,.72)),url(${Banner})`
                }}
            >

                <div className="about-banner-overlay"></div>

                <div className="about-banner-content">

                    <span className="about-banner-tag">

                        ✦ PREMIUM PHOTOGRAPHY & CINEMATIC FILMS ✦

                    </span>

                    <h1 className="about-banner-title">

                        About StoryLine Studios

                    </h1>

                    <div className="about-banner-divider"></div>

                    <p className="about-banner-text">

                        Capturing timeless love stories, genuine emotions,
                        and unforgettable celebrations through luxury
                        photography and cinematic storytelling.

                    </p>

                </div>

            </section>

            {/*=========================================================
                            ABOUT STUDIO
            =========================================================*/}

            <section className="about-section">

                <div className="about-container">

                    {/* Image */}

                    <div className="about-image">

                        <img

                            src={Studio}

                            alt="StoryLine Studios"

                            className="about-image-photo"

                        />

                        <div className="about-image-border"></div>

                    </div>

                    {/* Content */}

                    <div className="about-content">

                        <span className="about-small-title">

                            OUR STORY

                        </span>

                        <h2 className="about-title">

                            Crafting Memories That Last Forever

                        </h2>

                        <div className="about-title-line"></div>

                        <p className="about-description">

                            StoryLine Studios is a luxury photography and
                            cinematic film studio dedicated to preserving
                            life's most treasured moments with creativity,
                            elegance, and passion.

                        </p>

                        <p className="about-description">

                            From weddings and engagements to maternity,
                            baby photography, birthdays, family portraits,
                            and corporate events, every project is crafted
                            with artistic vision and meticulous attention
                            to detail.

                        </p>

                        <p className="about-description">

                            We believe every smile, every glance, and every
                            celebration deserves to become a timeless work
                            of art that families can cherish for generations.

                        </p>

                    </div>

                </div>

            </section>
                        {/*=========================================================
                        MISSION & VISION
            =========================================================*/}

            <section className="about-mission-section">

                <div className="about-mission-card">

                    <div className="about-card-icon">

                        🎯

                    </div>

                    <h2 className="about-card-title">

                        Our Mission

                    </h2>

                    <div className="about-card-divider"></div>

                    <p className="about-card-description">

                        To deliver exceptional photography and cinematic
                        experiences that preserve life's unforgettable
                        moments through creativity, innovation,
                        and heartfelt storytelling.

                    </p>

                </div>

                <div className="about-vision-card">

                    <div className="about-card-icon">

                        👑

                    </div>

                    <h2 className="about-card-title">

                        Our Vision

                    </h2>

                    <div className="about-card-divider"></div>

                    <p className="about-card-description">

                        To become one of the most trusted luxury
                        photography studios by creating timeless
                        masterpieces that exceed every client's
                        expectations.

                    </p>

                </div>

            </section>

            {/*=========================================================
                        WHY CHOOSE US
            =========================================================*/}

            <section className="about-why-section">

                <span className="about-small-title">

                    WHY CHOOSE US

                </span>

                <h2 className="about-why-title">

                    Experience Luxury. Capture Perfection.

                </h2>

                <div className="about-title-line"></div>

                <div className="about-why-grid">

                    <div className="about-why-card">

                        <div className="about-why-icon">

                            📸

                        </div>

                        <h3>

                            Professional Photography

                        </h3>

                        <p>

                            Elegant, creative and premium photography
                            tailored for every celebration.

                        </p>

                    </div>

                    <div className="about-why-card">

                        <div className="about-why-icon">

                            🎥

                        </div>

                        <h3>

                            Cinematic Films

                        </h3>

                        <p>

                            Beautiful storytelling through cinematic
                            wedding and event films.

                        </p>

                    </div>

                    <div className="about-why-card">

                        <div className="about-why-icon">

                            ✨

                        </div>

                        <h3>

                            Premium Editing

                        </h3>

                        <p>

                            Luxury color grading, artistic retouching,
                            and world-class editing quality.

                        </p>

                    </div>

                    <div className="about-why-card">

                        <div className="about-why-icon">

                            ❤️

                        </div>

                        <h3>

                            Client Satisfaction

                        </h3>

                        <p>

                            Every project is delivered with passion,
                            professionalism, and attention to detail.

                        </p>

                    </div>

                </div>

            </section>

            <Footer />

        </>

    );

}

export default AdminAbout;